function toArray(value) {
    return Array.isArray(value) ? value : (value ? [value] : []);
}

function normalizeKey(value, fallback = '') {
    return String(value || fallback || '')
        .trim()
        .replace(/\s+/g, '_')
        .replace(/[^a-zA-Z0-9_:-]/g, '')
        .toLowerCase();
}

export const REQUIRED_ATTACHMENT_TARGET_LABELS = {
    create: 'создание',
    submit: 'отправка',
    approve: 'согласование',
    reject: 'отклонение',
    return: 'возврат',
    assign: 'назначение',
    execute: 'взятие в работу',
    complete: 'завершение',
    partially_complete: 'частичное выполнение',
    accept: 'приемка',
    accept_partially: 'частичная приемка',
    cancel: 'отмена'
};

export const REQUIRED_ATTACHMENT_UPLOAD_ROLE_LABELS = {
    all: 'все участники',
    initiator: 'инициатор',
    approver: 'согласующий',
    assigner: 'назначающий',
    executor: 'исполнитель',
    observer: 'наблюдатель'
};

const DEFAULT_UPLOAD_ROLES_BY_TARGET = {
    create: ['initiator'],
    submit: ['initiator'],
    approve: ['approver'],
    reject: ['approver'],
    return: ['approver', 'executor', 'assigner'],
    assign: ['assigner'],
    execute: ['executor', 'assigner'],
    complete: ['executor', 'assigner'],
    partially_complete: ['executor', 'assigner'],
    accept: ['initiator'],
    accept_partially: ['initiator'],
    cancel: ['initiator']
};

export function normalizeRequiredAttachmentRule(rule, index = 0) {
    const source = rule && typeof rule === 'object' ? rule : {};
    const requiredFor = source.requiredFor ||
        source.required_for ||
        source.requiredForAction ||
        source.required_for_action ||
        source.action ||
        source.actions ||
        source.stage ||
        [];
    const minCount = Number(source.minCount || source.min_count || 1);
    const hasInitiatorChoiceFlag =
        Object.prototype.hasOwnProperty.call(source, 'initiatorChoice') ||
        Object.prototype.hasOwnProperty.call(source, 'initiator_choice') ||
        Object.prototype.hasOwnProperty.call(source, 'enabledByInitiator') ||
        Object.prototype.hasOwnProperty.call(source, 'enabled_by_initiator');
    const initiatorChoice = source.initiatorChoice === true ||
        source.initiator_choice === true ||
        source.enabledByInitiator === true ||
        source.enabled_by_initiator === true;
    const activationMode = hasInitiatorChoiceFlag
        ? (initiatorChoice ? 'initiator_choice' : 'always')
        : (source.activationMode || source.activation_mode || 'always');
    const uploadRoles = source.uploadRoles ||
        source.upload_roles ||
        source.allowedUploadRoles ||
        source.allowed_upload_roles ||
        source.uploaderRoles ||
        source.uploader_roles ||
        [];

    return {
        _uid: source._uid || `${Date.now()}_required_${index}_${Math.random()}`,
        key: normalizeKey(source.key || source.file_kind || source.fileKind, `attachment_${index + 1}`),
        active: source.active !== false && source.enabled !== false,
        label: String(source.label || source.name || 'Документ').trim(),
        requiredFor: toArray(requiredFor).map(action => String(action || '').trim()).filter(Boolean),
        minCount: Number.isInteger(minCount) && minCount > 0 ? minCount : 1,
        uploadRoles: toArray(uploadRoles).map(role => String(role || '').trim().toLowerCase()).filter(Boolean),
        activationMode,
        initiatorChoice: activationMode === 'initiator_choice'
    };
}

export function getRequiredAttachmentEnabledRuleKeys(workflowData) {
    const source = workflowData && typeof workflowData === 'object'
        ? (workflowData.requiredAttachments || workflowData.required_attachments || {})
        : {};
    const list = Array.isArray(source.enabledRuleKeys)
        ? source.enabledRuleKeys
        : (Array.isArray(source.enabled_rule_keys) ? source.enabled_rule_keys : []);

    return list.map(key => normalizeKey(key)).filter(Boolean);
}

export function isRequiredAttachmentRuleEnabledByWorkflowData(rule, workflowData) {
    if (!rule || !rule.initiatorChoice) {
        return true;
    }

    return getRequiredAttachmentEnabledRuleKeys(workflowData).includes(rule.key);
}

export function isRequiredAttachmentRuleEnabledByChoices(rule, choices) {
    if (!rule || !rule.initiatorChoice) {
        return true;
    }

    return Boolean(choices && choices[rule.key] === true);
}

export function getDefaultRequiredAttachmentUploadRoles(rule) {
    const roles = [];
    toArray(rule && rule.requiredFor).forEach(action => {
        toArray(DEFAULT_UPLOAD_ROLES_BY_TARGET[action]).forEach(role => {
            if (!roles.includes(role)) {
                roles.push(role);
            }
        });
    });

    return roles.length ? roles : ['initiator', 'approver', 'assigner', 'executor'];
}

export function getRequiredAttachmentUploadRoles(rule) {
    return rule && Array.isArray(rule.uploadRoles) && rule.uploadRoles.length
        ? rule.uploadRoles
        : getDefaultRequiredAttachmentUploadRoles(rule);
}

export function getRequiredAttachmentTargetsText(rule) {
    return toArray(rule && rule.requiredFor)
        .map(action => REQUIRED_ATTACHMENT_TARGET_LABELS[action] || action)
        .join(', ');
}

export function getRequiredAttachmentUploadRolesText(rule) {
    return getRequiredAttachmentUploadRoles(rule)
        .map(role => REQUIRED_ATTACHMENT_UPLOAD_ROLE_LABELS[role] || role)
        .join(', ');
}
